import { NgModule } from '@angular/core';
import { FormataInstituicaoPipe, FormataVacinaPipe } from "./formata-vacinas.pipe";

@NgModule({
  declarations: [
    FormataVacinaPipe,
    FormataInstituicaoPipe,
  ],
  imports: [

  ],
  exports: [
    FormataVacinaPipe,
    FormataInstituicaoPipe,
  ]
})
export class PipesModule { }
